class TermsAndConditions extends HTMLElement {
    constructor() {
        super();      
      	this.Binds();
    }
  
    Binds () {
      var self = this;
      this.parentNode.querySelector('.cart__checkout-button').addEventListener("click", function (event) {
        if (!self.querySelector('#enable_terms').checked) {
          event.preventDefault(); 
          
          if (self.querySelector('.error') == null) {
            var error = document.createElement('p');
            error.classList.add('error');
            error.innerHTML = "Dette felt er påkrævet";
            self.appendChild(error);
            
            if (!self.is_terms_bound) {
              self.querySelector('#enable_terms').addEventListener('change', function () {
                if (self.querySelector('.error')) {
                  self.querySelector('.error').parentNode.removeChild(self.querySelector('.error'));
                }
              }, true);
              self.is_terms_bound = true;
            }
          }
        } 
      });
    }
}

customElements.define("terms-and-conditions", TermsAndConditions);